import { find, pipe } from '@fxts/core';
import { generateProductListUrl } from '@services/MarppleShop/features/ProductList/util';
import { font } from '@services/MarppleShop/shared/typography';
import { makePlusUrl } from '@services/MarppleShop/shared/util/url.ts';
import { html, View } from 'rune-ts';
import headroom_klass from '../../libs/helpers/headroom.module.scss';
import { initHeadroom } from '../../libs/helpers/headroom.ts';
import { Menu } from '../../libs/types/header';
import klass from './CreatorShopSubHeaderCategory.module.scss';

/**
 * @desc 크리에이터 샵 모바일에서 사용하는 카테고리용 서브 헤더입니다.
 */
export class CreatorShopSubHeaderCategory extends View<{
  menus: Menu[];
  store_domain: string;
  plus_domain?: string;
}> {
  override template() {
    const selected_menu = this.#getSelectedMenu();

    return html`
      <div class="${klass.container}">
        <div class="${klass.sub_header}">${this.data.menus.map(this.#itemTemplate('main'))}</div>
        ${selected_menu?.sub_menus
          ? html`<div class="${klass.sub_header} ${klass.sub}">
              ${selected_menu?.sub_menus.map(this.#itemTemplate('sub', +selected_menu.key))}
            </div>`
          : ''}

        <script>
          document.querySelectorAll('.${klass.item}[data-selected="true"]').forEach((item) => {
            item.scrollIntoView({ behavior: 'instant', inline: 'start' });
          });
        </script>
      </div>
    `;
  }

  #getSelectedMenu() {
    return pipe(
      this.data.menus,
      find((menu) => menu.is_selected),
    );
  }

  #itemTemplate(type: 'main' | 'sub', cate_list_id?: number) {
    const plus_domain = this.data.plus_domain;
    const store_domain = this.data.store_domain;
    return function (menu: Menu) {
      return html`<a
        target="${menu.target || '_self'}"
        href="${type === 'main'
          ? makePlusUrl(plus_domain, menu.url)
          : generateProductListUrl({
              base_url: `${makePlusUrl(plus_domain, menu.url)}/${ET.lang}/${store_domain}/products`,
              cate_list_id,
              cate_item_id: +menu.key,
            })}"
        class="${klass.item} ${font('14_medium')}"
        data-selected="${menu.is_selected}"
        data-key="${menu.key}"
        data-type="${type}"
        >${menu.name}</a
      >`;
    };
  }

  override onRender() {
    const selected_menu = this.#getSelectedMenu();
    if (selected_menu?.sub_menus?.length) {
      initHeadroom(this.element(), {
        initial: headroom_klass.creator_header_category,
        pinned: headroom_klass.pinned,
        unpinned: headroom_klass.unpinned,
        disable_hook: true,
        offset: { up: 10, down: 10 },
      });
    }
  }
}
